import { render } from "./EditAlarmcodesForOrganisation.vue?vue&type=template&id=5001ad88"
import script from "./EditAlarmcodesForOrganisation.vue?vue&type=script&lang=js"
export * from "./EditAlarmcodesForOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__